import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
@Component({
  selector: 'app-help-seccontent',
  templateUrl: './help-seccontent.component.html'
})
export class HelpSeccontentComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService, private sanitizer: DomSanitizer, private router: Router) { }
  sec_heading;
  sec_desc;
  sec_para1heading;
  sec_para1body;

  ngOnInit(): void {
   
    this.commonDataService.showLoader.next(true);
    this.getseccontentlabels();
  }
  getseccontentlabels() {
    this.graphQlService.gethelpseccontentLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.sec_heading = labels.filter(x => x.key == "sec_heading").map(y => y.value);
        this.sec_desc = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "sec_desc").map(y => y.value));
        this.sec_para1heading = labels.filter(x => x.key == "sec_para1heading").map(y => y.value);
        this.sec_para1body = labels.filter(x => x.key == "sec_para1body").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });

  }
  openlinkbyId(event) {
    let id = event.target.id;
    if (id != "") {
      this.router.navigate([event.target.id]);
    }

  }
}
